import { useHotelPolicyI18nEditMutation } from "../../repository";

import type { AccommodationHotelPolicyI18nFormModel } from "../../type";

type Props = {
	viewModel: AccommodationHotelPolicyI18nFormModel["ViewModel"];
	resetForm: () => void;
};

export const useUpdateHotelPolicyI18n = ({ viewModel, resetForm }: Props) => {
	const { onUpdateHotelPolicyI18n } = useHotelPolicyI18nEditMutation({ viewModel, resetForm });

	return {
		onUpdateHotelPolicyI18n,
	};
};
